import { Component, OnInit } from '@angular/core';
import { AppService } from '../../app.service';
import { Router } from '@angular/router';

import $ from 'jquery';

@Component({
  selector: 'app-daughter',
  templateUrl: './daughter.component.html',
  styleUrls: ['./daughter.component.scss']
})
export class DaughterEligibilityComponent implements OnInit {

  deceased = this.appState.get();
  	all_conditions: boolean = false;
	
	constructor(public appState: AppService, public router: Router) {
		this.appState = this.appState;
	}

	// Form Validation
	formValidate() {

	    // Step#1: Required Inputs and Selects   
	    var inputs = document.querySelectorAll("*[required]");

	    if( inputs.length > 0 ) {
	      for (var i = 0; i < inputs.length; ++i) {
	        var input_elem = <HTMLInputElement>inputs[i];

	        if( input_elem.value == '' ) {
	          inputs[i].parentElement.classList.add("has-error");  
	          input_elem.focus();

	          $('html, body').animate({
	              scrollTop: $( ".has-error" ).offset().top
	          }, 500);

	          return false;
	        
	        } else {
	          inputs[i].parentElement.classList.remove("has-error");  
	        }
	      }
	    }



	    // Step#2: Check Radio Buttons whether they are checked or not
	    var error = false;
	    var radio_buttons_wrap = document.querySelectorAll(".radio-buttons-wrap");

	    for (var i = 0; i < radio_buttons_wrap.length; ++i) {
	      var radio = radio_buttons_wrap[i].querySelectorAll("input[type='radio']");
	      var checked = false;
	      
	      for (var k = 0; k < radio.length; ++k) {
	        var radio_elem = <HTMLInputElement>radio[k];

	        if( radio_elem.checked ) {
	          checked = true;
	          break;
	        }
	      }

	      if( ! checked ) {
	        radio_buttons_wrap[i].parentElement.classList.add("has-error");

	        $('html, body').animate({
	            scrollTop: $( ".has-error" ).offset().top
	        }, 500);

	        return false;

	      } else {
	        radio_buttons_wrap[i].parentElement.classList.remove("has-error");
	      }
	    }


	    return true;
	}

	// Eligibility Check
	eligibilityCheck(deceased: any = false) {
		if( deceased ) {
			this.deceased = deceased;
		}
		
	    if( this.deceased.survivors == 'true' && this.deceased['daughter'].count > 0 ) {

	        for (var k = 0; k < this.deceased['daughter'].count; ++k) {
	          
	          var this_daughter = this.deceased['daughter'].object[k];

	          // If All Fields empty Continue without Checking
	          if( this_daughter.muslim == "" && this_daughter.legitimate == "" && this_daughter.deceased_killer == "" && (this_daughter.free_person == "true" || this_daughter.free_person == "") && ((this.deceased.gender == 'Male' && this_daughter.disowned == "") || this.deceased.gender == 'Female')  ) {
	            
	            if( deceased ) {
	            	return undefined;
	            }

	            this.deceased['daughter'].object[k].eligibility = "";
	            continue;

	          // Otherwise Check
	          } else {
	            if( this_daughter.muslim == "true" && this_daughter.legitimate == "true" && this_daughter.deceased_killer == "true" && this_daughter.free_person == "true" && ((this.deceased.gender == 'Male' && this_daughter.disowned == "true") || this.deceased.gender == 'Female') ) {
	              
	              this.deceased['daughter'].object[k].eligibility = "true";
	              this.all_conditions = true;
	            
	            } else {
	              
	              this.deceased['daughter'].object[k].eligibility = "false";
	              if( this.all_conditions == false )  {
	                this.all_conditions = false;
	              }

	            }
	          }

	        }

	        return this.all_conditions;
	    }
	}


	setValues() {

		if( this.deceased.survivors == 'true' && this.deceased['daughter'].count > 0 ) {

	        for (var k = 0; k < this.deceased['daughter'].count; ++k) {
	          
	          var this_daughter = this.deceased['daughter'].object[k];

	          // If All Fields empty Continue without Checking
	          if( this_daughter.muslim == "" ) {
	          	this.deceased['daughter'].object[k].muslim = "false";
	          } 

	          if( this_daughter.legitimate == "" ) {
	          	this.deceased['daughter'].object[k].legitimate = "false";
	          } 

	          if( this_daughter.deceased_killer == "" ) {
	          	this.deceased['daughter'].object[k].deceased_killer = "false";
	          } 

	          if( this_daughter.free_person == "" ) {
	          	this.deceased['daughter'].object[k].free_person = "false";
	          }

	        }

	    }
	}


	// Back Button
	back(event) {
		this.router.navigate(['level1-inheritors']);		
		event.preventDefault();
	}

	// Next Button is clicked
	next(event) {

		// Form Validation
	    if( this.formValidate() == false ) {
	      return;
	    }

		// Eligibility Test
		this.eligibilityCheck();

    	// Save
		this.appState.set(this.deceased);

		// Redirect to Results Page
		this.router.navigate(['level1-inheritors']);

		event.preventDefault();

	}

  ngOnInit() {
  }

}
